import logging from '../logging';
import { Box3, Object3D } from 'three';
import { Door, Handle, ParametricPart, Section } from '../domain';
import { clamp } from '../math/clamp';
import { getGeometrySize } from '../geometry';
import { approx, round2slot } from '../measurement';

const log = logging('doorControllers');

const box = new Box3();

export const setHandleDirection = (handle: Handle, obj: Object3D, direction: 'h' | 'v', flip?: 'r') => {

    if(handle.assetId) {
        if(direction = 'v') {
            handle.rotation.z = -Math.PI/2;

            if(obj) getGeometrySize(obj, box);
            const
                width = box.max.x - box.min.x,
                height = box.max.y - box.min.y;
            if(width > 0 && width/height > 1.5) {
                obj.position.x = -width/2;
            } else if(width == 0) {
                log.error("doorControllers setHandleDirection: handle appears to have zero width; likely a loading problem");
            }
        }
        if(flip == 'r') {
            handle.scale.y = -1;
        }
    } else {
        let style: string;
        if(direction == 'h') {
            style = handle.style.replace(/^d-v/, 'd-h');
        } else {
            style = handle.style.replace(/^d-h/, 'd-v');
        }

        const ext = style.slice(-3); // expected obj or glb

        style = style.replace(/r?.(glb|obj)$/, '');
        if(flip == 'r') {
            handle.style = style + `r.${ext}`;
        } else {
            handle.style = style + `.${ext}`;
        }
    }
}

export const IDEAL_HANDLE_HEIGHT = 42;

/**
 * This only works for Doors with left and right hinges. If called on a drawer
 * or a top- or bottom-hinged door, you will not get the right appearance. The
 * height parameter refers to the actual height of the handle's 3D model.
 */
export const setHandleHeight = (elevation: number, handle: Handle, height: number) => {
    const
        door = handle.parent as Door,
        min = 2,
        max = door.height - 2 - (height > 2 ? height : 0);

    handle.position.y = clamp(IDEAL_HANDLE_HEIGHT - elevation, min, max);
}

/**
 * Find a door that is bounded by the given shelf and adjust its size to match
 * the shelf's new position at y.
 */
export const resizeDoorByFixedShelf = (shelf: ParametricPart, section: Section, y: number) => {
    for(const door of section.doors) {
        const
            bottom = door.position.y,
            top = bottom + door.height;
        if(approx(bottom, shelf.position.y)) {
            door.position.y = y;
            door.height = top - y;
        }
        if(approx(top, shelf.position.y)) {
            door.height = y - bottom;
        }
    }
};


type AdjacentDoors = [above: Door|null, below: Door|null];

/**
 * Returns a two-tuple of DoorViews if a door exists directly above or below
 * the given shelf.
 */
export const getAdjacentDoors = (section: Section, shelf: ParametricPart): AdjacentDoors =>
{
    const
        y = round2slot(shelf.position.y),
        result: AdjacentDoors = [null, null];
    for(const door of section.doors) {
        const
            bottom = round2slot(door.position.y),
            top = round2slot(bottom + door.height);
        if(y == bottom)
        {
            result[0] = door;
        } else if(y == top) {
            result[1] = door;
        }
    }
    return result;
}

